export default __webpack_public_path__ + "static/media/19_desktop.057b215d.jpg";